export default __webpack_public_path__ + "static/media/technological-treatments.7c704bd1.png";